import { TFunction } from 'i18next';

export const sortOptions = (t: TFunction) => [
  {
    label: t('pages.shops.default'),
    value: 'default',
    dataStat: 'shops-order-default',
  },
  {
    label: t('pages.shops.by_count'),
    value: 'count',
    dataStat: 'shops-order-ads-count',
  },
  {
    label: t('pages.shops.by_popularity'),
    value: 'popularity',
    dataStat: 'shops-order-popularity',
  },
  {
    label: t('pages.shops.by_name'),
    value: 'name',
    dataStat: 'shops-order-name-asc',
  },
  {
    label: t('pages.shops.by_name_reverse'),
    value: 'name-reverse',
    dataStat: 'shops-order-name-desc',
  },
];
